
//always start at the top of the page
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    window.scrollTo(0, 0);
  }, 0);

  setupEyesVideoLazyLoad();
});


// Texture loading: lazy on first use, idle-prefetch after page load
window.rtdTextureCache = {};
window._rtdTextureUrls = {
    mocha: {
        main:  'https://static.onyxcontent.com/rtd-textures/mocha_main.webp',
        metal: 'https://static.onyxcontent.com/rtd-textures/mocha_metal.webp'
    },
    od: {
        main:  'https://static.onyxcontent.com/rtd-textures/od_main.webp',
        metal: 'https://static.onyxcontent.com/rtd-textures/od_metal.webp'
    },
    chai: {
        main:  'https://static.onyxcontent.com/rtd-textures/chai_main.webp',
        metal: 'https://static.onyxcontent.com/rtd-textures/chai_metal.webp'
    },
    ube: {
        main:  'https://static.onyxcontent.com/rtd-textures/ube_main.webp',
        metal: 'https://static.onyxcontent.com/rtd-textures/ube_metal.webp'
    },
    matcha: {
        main:  'https://static.onyxcontent.com/rtd-textures/matcha_main.webp',
        metal: 'https://static.onyxcontent.com/rtd-textures/matcha_metal.webp'
    }
};
window._rtdTexturePromises = {};

window.rtdEnsureTexture = function(can) {
    if (window._rtdTexturePromises[can]) return window._rtdTexturePromises[can];
    var urls = window._rtdTextureUrls[can];
    if (!urls) return Promise.resolve();

    window.rtdTextureCache[can] = window.rtdTextureCache[can] || {};
    var fetches = [];
    for (var layer in urls) {
        (function(c, l, url) {
            if (window.rtdTextureCache[c][l]) return;
            fetches.push(
                fetch(url)
                    .then(function(r) { return r.arrayBuffer(); })
                    .then(function(buf) { window.rtdTextureCache[c][l] = new Uint8Array(buf); })
                    .catch(function(e) { console.warn('Failed to fetch texture:', c + '.' + l, e); })
            );
        })(can, layer, urls[layer]);
    }
    window._rtdTexturePromises[can] = Promise.all(fetches);
    return window._rtdTexturePromises[can];
};

// After the page is fully loaded, prefetch remaining textures during idle time
window.addEventListener('load', function() {
    var cans = Object.keys(window._rtdTextureUrls);
    var idx = 0;
    function prefetchNext(deadline) {
        while (idx < cans.length && deadline.timeRemaining() > 0) {
            window.rtdEnsureTexture(cans[idx]);
            idx++;
        }
        if (idx < cans.length) {
            requestIdleCallback(prefetchNext, { timeout: 3000 });
        }
    }
    if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(prefetchNext, { timeout: 3000 });
    } else {
        setTimeout(function() {
            for (var i = 0; i < cans.length; i++) {
                window.rtdEnsureTexture(cans[i]);
            }
        }, 2000);
    }
});

// Taste with your eyes: one video URL per flavor
window.rtdEyesVideos = {
    od:     'https://cdn.shopify.com/videos/c/o/v/860489892a404b22a36485cbae898fa0.mp4',
    mocha:  'https://cdn.shopify.com/videos/c/o/v/98c039bb26dd402aaf021dee88c3c51b.mp4',
    ube:    'https://cdn.shopify.com/videos/c/o/v/7ef83024e7f04ab1bd624aa85a146e15.mp4',
    matcha: 'https://cdn.shopify.com/videos/c/o/v/0038bce2c2544057a717e4fecd6f8999.mp4',
    chai:   'https://cdn.shopify.com/videos/c/o/v/e71bf096810c4b40861054eca9bc0bed.mp4'
};

window._eyesSectionVisible = false;

function setupEyesVideoLazyLoad() {
    var eyesSection = document.querySelector('.eyes');
    if (!eyesSection) return;

    var observer = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
                window._eyesSectionVisible = true;
                updateRtdEyesVideos(window._currentTexture || 'od');
                observer.unobserve(eyesSection);
                break;
            }
        }
    }, { threshold: 0.1 });

    observer.observe(eyesSection);
}

function updateRtdEyesVideos(flavorKey) {
    if (!window._eyesSectionVisible) return;
    var url = window.rtdEyesVideos && window.rtdEyesVideos[flavorKey];
    if (!url) return;
    var v = document.getElementById('eyes-vid');
    if (!v || v.src === url) return;
    v.pause();
    v.src = url;
    v.load();
    v.play().catch(function() {});
}

window._currentTexture = "od";
window._textureTransitioning = false;
window._rtdSelectedFlavor = "od";
window._rtdPendingFlavor = null;
window._rtdQueuedTexture = null;

window.setRtdFlavor = function(can) {
    var main = document.querySelector("main");
    if (!main || !can) return;
    main.className = main.className.replace(/\bflavor-\w+/g, '') + ' flavor-' + can;
};

// Map a Shopify variant to one of the page flavor keys by scanning its
// title/options. Returns "mixr" for the mixed/variety pack.
window.rtdFlavorFromVariant = function(variant) {
    if (!variant) return null;
    var haystack = [variant.title, variant.option1, variant.option2, variant.option3]
        .filter(Boolean).join(" ").toLowerCase();
    var keywords = {
        mixr:   ["mixr", "mix pack", "variety"],
        od:     ["onyx delight", "delight"],
        mocha:  ["mocha"],
        ube:    ["ube"],
        matcha: ["matcha"],
        chai:   ["chai"]
    };
    for (var key in keywords) {
        for (var i = 0; i < keywords[key].length; i++) {
            if (haystack.indexOf(keywords[key][i]) !== -1) return key;
        }
    }
    return null;
};

// Apply a flavor across the whole page: selector states, copy panels,
// background gradient, can textures, and the "eyes" video.
// opts.mixedCans keeps the non-hero cans in their own original colors
// (used for the mixr pack) instead of matching the selected flavor.
window.rtdApplyFlavor = function(name, opts) {
    opts = opts || {};
    if (!name || !window._rtdTextureUrls[name]) return;
    window._rtdSelectedFlavor = name;

    $(".color-selector.active").removeClass("active");
    $(".color-selector[data-name='" + name + "']").addClass("active");
    $(".lineup-detail.active").removeClass("active");
    $(".lineup-detail[data-name='" + name + "']").addClass("active");
    $(".quality-notes.active").removeClass("active");
    $(".quality-notes[data-name='" + name + "']").addClass("active");

    if (window.splineblob && window.rtdLoadState && window.rtdLoadState.splineReady) {
        window.transition_texture(name);
    } else {
        // Spline isn't ready yet (e.g. variant deeplink on page load):
        // recolor the page now, swap the can texture once the scene starts
        window.setRtdFlavor(name);
        window._rtdPendingFlavor = name;
    }
    window.rtdSetOtherCans(opts.mixedCans ? null : name);
    updateRtdEyesVideos(name);
};

// Keep the page flavor in sync with the purchase variant
document.addEventListener("variant:changed", function(e) {
    var variant = e.detail && e.detail.variant;
    var flavor = window.rtdFlavorFromVariant(variant);
    if (!flavor) return;
    if (flavor === "mixr") {
        // Mixr pack: hero can back to Onyx Delight, other cans keep their own colors
        window.rtdApplyFlavor("od", { mixedCans: true });
        return;
    }
    if (flavor !== window._rtdSelectedFlavor) {
        window.rtdApplyFlavor(flavor);
    }
});

// ============================================
// Non-hero cans: recolor to the selected flavor
// (or restore their own colors when flavor is null)
// ============================================
window._rtdOtherCanObjects = {
    ube:    { grab: 'Ube_Grab',    inner: 'Ube_Inner' },
    mocha:  { grab: 'Mocha_Grab',  inner: 'Mocha_Inner' },
    chai:   { grab: 'Chai_Grab',   inner: 'Chai_Inner' },
    matcha: { grab: 'Matcha_Grab', inner: 'Matcha_Inner' }
};
window._rtdOtherCansFlavor = null;   // desired state (null = each can its own color)
window._rtdOtherCansApplied = null;  // what's currently on the cans
window._rtdOtherCansCurrent = { ube: 'ube', mocha: 'mocha', chai: 'chai', matcha: 'matcha' };
window._rtdOtherCansGen = 0;

window.rtdSetOtherCans = function(flavor) {
    window._rtdOtherCansFlavor = flavor || null;
    rtdApplyOtherCans();
};

// Fade a material layer's alpha (0-100), same as the hero can's transition cover
function rtdAnimateLayerAlpha(layer, from, to, duration) {
    return new Promise(function(resolve) {
        if (typeof anime === 'undefined') {
            layer.alpha = to / 100;
            resolve();
            return;
        }
        var target = { value: from };
        anime({
            targets: target,
            value: to,
            duration: duration,
            easing: 'easeInOutQuad',
            update: function() {
                layer.alpha = target.value / 100;
            },
            complete: resolve
        });
    });
}

// 360° spin around the can's upright (y) axis; the tilted outer groups mean
// the hero's z-axis spin doesn't read correctly on these cans
function rtdSpinCanObject(objectName, duration) {
    if (typeof anime === 'undefined' || !window.splineblob) return;
    var obj = window.splineblob.findObjectByName(objectName);
    if (!obj) return;
    var startY = obj.rotation.y;
    var target = { t: 0 };
    anime({
        targets: target,
        t: 1,
        duration: duration,
        easing: 'easeOutCubic',
        update: function() {
            obj.rotation.y = startY + Math.PI * 2 * target.t;
        }
    });
}

function rtdApplyOtherCans() {
    // Retried from rtdSplineLoaded if the scene isn't ready yet
    if (!window.splineblob || !window.rtdLoadState || !window.rtdLoadState.splineReady) return;

    var target = window._rtdOtherCansFlavor;
    if (target === window._rtdOtherCansApplied) return;
    window._rtdOtherCansApplied = target;

    var gen = ++window._rtdOtherCansGen;
    Object.keys(window._rtdOtherCanObjects).forEach(function(ownFlavor) {
        var tex = target || ownFlavor;
        if (window._rtdOtherCansCurrent[ownFlavor] === tex) return;

        window.rtdEnsureTexture(tex).then(function() {
            if (gen !== window._rtdOtherCansGen) return;

            var names = window._rtdOtherCanObjects[ownFlavor];
            var obj = window.splineblob.findObjectByName(names.grab);
            if (!obj || !obj.material) return;

            var mainLayer = obj.material.layers.find(function(l) {
                return l.type === 'texture' && l.texture?.image?.name?.includes('main');
            });
            var metalLayer = obj.material.layers.find(function(l) {
                return l.type === 'texture' && l.texture?.image?.name?.includes('metal');
            });

            var cached = window.rtdTextureCache[tex] || {};
            var transitionLayer = obj.material.layers[8];

            rtdSpinCanObject(names.inner, 800);

            function swapTextures() {
                window._rtdOtherCansCurrent[ownFlavor] = tex;
                var updates = [];
                if (mainLayer && cached.main) updates.push(mainLayer.updateTexture(cached.main));
                if (metalLayer && cached.metal) updates.push(metalLayer.updateTexture(cached.metal));
                return Promise.all(updates);
            }

            if (transitionLayer) {
                // Same cover fade the hero can uses: fade up, swap underneath, fade back
                rtdAnimateLayerAlpha(transitionLayer, 0, 100, 200).then(function() {
                    if (gen !== window._rtdOtherCansGen) {
                        rtdAnimateLayerAlpha(transitionLayer, 100, 0, 200);
                        return;
                    }
                    swapTextures().then(function() {
                        rtdAnimateLayerAlpha(transitionLayer, 100, 0, 200);
                    });
                });
            } else {
                // No transition layer on this material: swap mid-spin instead
                setTimeout(function() {
                    if (gen !== window._rtdOtherCansGen) return;
                    swapTextures();
                }, 200);
            }
        });
    });
}

window.transition_texture = async function(can){

    if (can === window._currentTexture) return;
    if (window._textureTransitioning) {
        // Remember the latest request so rapid flavor/variant changes aren't dropped
        window._rtdQueuedTexture = can;
        return;
    }
    window._textureTransitioning = true;

    const obj = window.splineblob.findObjectByName('OD_Grab');

    const textureLayer = obj.material.layers.find(
        (l) => l.type === 'texture' && l.texture?.image?.name?.includes('main')
    );

    const metalLayer = obj.material.layers.find(
        (l) => l.type === 'texture' && l.texture?.image?.name?.includes('metal')
    );

    const transitionLayer = obj.material.layers[8];

    function animateOpacity(layer, from, to, duration) {
        return new Promise(function(resolve) {
            var target = { value: from };
            anime({
                targets: target,
                value: to,
                duration: duration,
                easing: 'easeInOutQuad',
                update: function() {
                    layer.alpha = target.value / 100;
                },
                complete: resolve
            });
        });
    }

    function spinObject(obj, duration) {
        var startY = obj.rotation.z;
        return new Promise(function(resolve) {
            var target = { t: 0 };
            anime({
                targets: target,
                t: 1,
                duration: duration,
                easing: 'easeOutCubic',
                update: function() {
                    obj.rotation.z = startY + Math.PI * 2 * target.t;
                },
                complete: resolve
            });
        });
    }

    window.setRtdFlavor(can);

    // Fade up transition layer + spin simultaneously
    var spinDuration = 800;

    
    var fadeUpDone = animateOpacity(transitionLayer, 0, 100, 200);

    // Wait for fade-up to finish, then swap textures under the cover

    spinObject(obj, spinDuration)

    await fadeUpDone;

    await window.rtdEnsureTexture(can);
    var cached = window.rtdTextureCache[can];
    if (textureLayer && cached && cached.main) {
        await textureLayer.updateTexture(cached.main);
    }
    if (metalLayer && cached && cached.metal) {
        await metalLayer.updateTexture(cached.metal);
    }

    animateOpacity(transitionLayer, 100, 0, 200)

    window._currentTexture = can;
    window._textureTransitioning = false;

    if (window._rtdQueuedTexture) {
        var queued = window._rtdQueuedTexture;
        window._rtdQueuedTexture = null;
        window.transition_texture(queued);
    }

}


// ============================================
// RTD Page Loading System
// ============================================
window.rtdLoadState = {
    splineReady: false,
    domReady: false
};

// Call this when Spline finishes loading
window.rtdSplineLoaded = function() {
    window.rtdLoadState.splineReady = true;
    if (window._rtdPendingFlavor) {
        var pending = window._rtdPendingFlavor;
        window._rtdPendingFlavor = null;
        window.transition_texture(pending);
    }
    rtdApplyOtherCans();
    rtdCheckAllLoaded();
};

// Check if everything is loaded
function rtdCheckAllLoaded() {
    if (window.rtdLoadState.splineReady && window.rtdLoadState.domReady) {
        rtdOnAllLoaded();
    }
}

// ============================================
// HOOK: This fires when everything is loaded
// ============================================
// ============================================
// Intro Animations (non-scroll, fires once on load)
// ============================================
function rtdIntroDesktop() {


    rtdSpline.animateObject('OD_Outer', {
        from: { position: { y: -600, z: 0, x: -10, z: 10} },
        to: { position: { y: 10, z: 0, x: -10, z: 50 } },
        duration: 2500,
        easing: 'easeOutQuart'
    })


    rtdSpline.animateObject('Ube_Outer', {
        from: { position: { y: -600, x: 40, z: 0}, rotation: {z:0} },
        to: { position: { y: 60, x: 30, z: 160},rotation: {z:Math.PI/6} },
        duration: 2500,
        easing: 'easeOutQuart'
    })
    rtdSpline.animateObject('Mocha_Outer', {
        from: { position: { y: -600, x: 60} },
        to: { position: { y: -100, x: 60} },
        duration: 2500,
        easing: 'easeOutQuart'
    })
    rtdSpline.animateObject('Matcha_Outer', {
        from: { position: { y: -600, x: 0, z: 0}, rotation: {z:0} },
        to: { position: { y: -40, x: -40, z: 150}, rotation: {z:Math.PI/12} },
        duration: 2500,
        easing: 'easeOutQuart'
    })
    rtdSpline.animateObject('Chai_Outer', {
        from: { position: { y: -600, x: -70}, rotation: {z:0} },
        to: { position: { y: 100, x: -70}, rotation: {z:-Math.PI/6} },
        duration: 2500,
        easing: 'easeOutQuart'
    })

}

function rtdIntroMobile() {

    rtdSpline.animateObject('OD_Outer', {
        from: { position: { y: -600, z: 0, x: -10, z: 10} },
        to: { position: { y: 10, z: 0, x: -10, z: 50 } },
        duration: 2500,
        easing: 'easeOutQuart'
    })


    rtdSpline.animateObject('Ube_Outer', {
        from: { position: { y: -600, x: 40, z: 0}, rotation: {z:0} },
        to: { position: { y: 60, x: 30, z: 160},rotation: {z:Math.PI/6} },
        duration: 2500,
        easing: 'easeOutQuart'
    })
    rtdSpline.animateObject('Mocha_Outer', {
        from: { position: { y: -600, x: 50} },
        to: { position: { y: -100, x: 50} },
        duration: 2500,
        easing: 'easeOutQuart'
    })
    rtdSpline.animateObject('Matcha_Outer', {
        from: { position: { y: -600, x: 0, z: 0}, rotation: {z:0} },
        to: { position: { y: -40, x: -40, z: 150}, rotation: {z:Math.PI/12} },
        duration: 2500,
        easing: 'easeOutQuart'
    })
    rtdSpline.animateObject('Chai_Outer', {
        from: { position: { y: -600, x: -50}, rotation: {z:0} },
        to: { position: { y: 100, x: -50}, rotation: {z:-Math.PI/6} },
        duration: 2500,
        easing: 'easeOutQuart'
    })

    



}

function rtdOnAllLoaded() {
    console.log('RTD: All resources loaded');
    
    // Hide the loader
    var loader = document.getElementById('rtd-loader');
    if (loader) {
        setTimeout(function(){
            loader.classList.add('hidden');


                if (window.innerWidth < 800) {
                    rtdIntroMobile();
                } else {
                    rtdIntroDesktop();
                }


        }, 10)
    }

    setupDragToSpin();
}


// ============================================
// Drag-to-Spin: click/touch-drag scene objects
// to rotate them along the Y axis
// ============================================
function setupDragToSpin() {
    var canvas = document.getElementById('canvas3d');
    if (!canvas || !window.splineblob) return;

    var spinnableNames = ['Ube_Grab', 'Mocha_Grab', 'Chai_Grab', 'Matcha_Grab', 'OD_Grab'];

    var SENSITIVITY    = 0.008;
    var DAMPING        = 0.95;
    var MIN_VELOCITY   = 0.0001;

    var drag = {
        object: null,
        lastX: 0,
        velocityY: 0,
        inertiaRaf: null
    };

    splineblob.addEventListener('mouseDown', function(e) {
        console.log(e.target.name)
        if (!e.target) return;
        if (spinnableNames.indexOf(e.target.name) !== -1) {
            var obj = rtdSpline.getObject(e.target.name);
            if (obj) {
                if (drag.inertiaRaf) {
                    cancelAnimationFrame(drag.inertiaRaf);
                    drag.inertiaRaf = null;
                }
                drag.object = obj;
            }
        }
    });

    canvas.addEventListener('pointerdown', function(e) {
        drag.lastX = e.clientX;
        drag.velocityY = 0;
    });

    window.addEventListener('pointermove', function(e) {
        if (!drag.object) return;

        var deltaX = e.clientX - drag.lastX;
        drag.lastX = e.clientX;
        drag.velocityY = deltaX * SENSITIVITY;
        drag.object.rotation.z += drag.velocityY;
    });

    window.addEventListener('pointerup', function() {
        if (!drag.object) return;
        var obj = drag.object;
        drag.object = null;

        if (Math.abs(drag.velocityY) > MIN_VELOCITY) {
            (function coast() {
                drag.velocityY *= DAMPING;
                if (Math.abs(drag.velocityY) < MIN_VELOCITY) {
                    drag.inertiaRaf = null;
                    return;
                }
                obj.rotation.z += drag.velocityY;
                drag.inertiaRaf = requestAnimationFrame(coast);
            })();
        }
    });
}


// ============================================
// RTD Spline Animation System
// ============================================
// Helpers for scroll-tied Spline animations with
// support for keyframes, easing, and multi-property animations.

window.rtdSpline = (function(){

    // RAF coalescing for performance
    var pendingOps = [];
    var rafId = null;
    
    function queueUpdate(fn) {
        pendingOps.push(fn);
        if (!rafId) {
            rafId = requestAnimationFrame(function(){
                var ops = pendingOps;
                pendingOps = [];
                rafId = null;
                for (var i = 0; i < ops.length; i++) {
                    try { ops[i](); } catch(e) { console.error(e); }
                }
            });
        }
    }

    // Easing functions (input/output 0-1)
    var easings = {
        linear: function(t) { return t; },
        easeIn: function(t) { return t * t * t; },
        easeOut: function(t) { return 1 - Math.pow(1 - t, 3); },
        easeInOut: function(t) {
            return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        },
        easeInQuad: function(t) { return t * t; },
        easeOutQuad: function(t) { return 1 - (1 - t) * (1 - t); },
        easeInOutQuad: function(t) {
            return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        }
    };

    // Interpolate between two values
    function lerp(from, to, t) {
        return from + (to - from) * t;
    }

    // Interpolate through keyframes array: [{at: 0, value: X}, {at: 0.5, value: Y}, ...]
    function keyframeLerp(keyframes, progress) {
        if (!keyframes || keyframes.length === 0) return 0;
        if (keyframes.length === 1) return keyframes[0].value;
        
        // Find the two keyframes we're between
        for (var i = 0; i < keyframes.length - 1; i++) {
            var curr = keyframes[i];
            var next = keyframes[i + 1];
            if (progress >= curr.at && progress <= next.at) {
                var segmentProgress = (progress - curr.at) / (next.at - curr.at);
                return lerp(curr.value, next.value, segmentProgress);
            }
        }
        
        // Outside range - clamp to first/last
        if (progress < keyframes[0].at) return keyframes[0].value;
        return keyframes[keyframes.length - 1].value;
    }

    // Set a Spline variable (with RAF coalescing)
    function setVar(name, value) {
        queueUpdate(function(){
            if (window.splineblob) {
                window.splineblob.setVariable(name, value);
            }
        });
    }

    // Set multiple Spline variables at once
    function setVars(vars) {
        queueUpdate(function(){
            if (window.splineblob) {
                for (var name in vars) {
                    window.splineblob.setVariable(name, vars[name]);
                }
            }
        });
    }

    // ========================================
    // Object Transform Helpers
    // ========================================
    
    // Cache for looked-up objects
    var objectCache = {};

    // Get a Spline object by name (cached)
    function getObject(name) {
        if (objectCache[name]) return objectCache[name];
        if (window.splineblob) {
            var obj = window.splineblob.findObjectByName(name);
            if (obj) objectCache[name] = obj;
            return obj;
        }
        return null;
    }

    // Clear object cache (call if scene reloads)
    function clearObjectCache() {
        objectCache = {};
    }

    // Set object position { x, y, z }
    function setPosition(objectName, pos) {
        queueUpdate(function(){
            var obj = getObject(objectName);
            if (obj) {
                if (pos.x !== undefined) obj.position.x = pos.x;
                if (pos.y !== undefined) obj.position.y = pos.y;
                if (pos.z !== undefined) obj.position.z = pos.z;
            }
        });
    }

    // Set object rotation { x, y, z } (in radians)
    function setRotation(objectName, rot) {
        queueUpdate(function(){
            var obj = getObject(objectName);
            if (obj) {
                if (rot.x !== undefined) obj.rotation.x = rot.x;
                if (rot.y !== undefined) obj.rotation.y = rot.y;
                if (rot.z !== undefined) obj.rotation.z = rot.z;
            }
        });
    }

    // Set object scale { x, y, z } or single number for uniform
    function setScale(objectName, scale) {
        queueUpdate(function(){
            var obj = getObject(objectName);
            if (obj) {
                if (typeof scale === 'number') {
                    obj.scale.x = scale;
                    obj.scale.y = scale;
                    obj.scale.z = scale;
                } else {
                    if (scale.x !== undefined) obj.scale.x = scale.x;
                    if (scale.y !== undefined) obj.scale.y = scale.y;
                    if (scale.z !== undefined) obj.scale.z = scale.z;
                }
            }
        });
    }

    // Set all transforms at once
    function setTransform(objectName, transform) {
        queueUpdate(function(){
            var obj = getObject(objectName);
            if (!obj) return;
            
            if (transform.position) {
                if (transform.position.x !== undefined) obj.position.x = transform.position.x;
                if (transform.position.y !== undefined) obj.position.y = transform.position.y;
                if (transform.position.z !== undefined) obj.position.z = transform.position.z;
            }
            if (transform.rotation) {
                if (transform.rotation.x !== undefined) obj.rotation.x = transform.rotation.x;
                if (transform.rotation.y !== undefined) obj.rotation.y = transform.rotation.y;
                if (transform.rotation.z !== undefined) obj.rotation.z = transform.rotation.z;
            }
            if (transform.scale) {
                if (typeof transform.scale === 'number') {
                    obj.scale.x = transform.scale;
                    obj.scale.y = transform.scale;
                    obj.scale.z = transform.scale;
                } else {
                    if (transform.scale.x !== undefined) obj.scale.x = transform.scale.x;
                    if (transform.scale.y !== undefined) obj.scale.y = transform.scale.y;
                    if (transform.scale.z !== undefined) obj.scale.z = transform.scale.z;
                }
            }
        });
    }

    // Helper to interpolate transform objects
    function lerpTransform(from, to, t) {
        var result = {};
        
        if (from.position || to.position) {
            result.position = {};
            var fp = from.position || {};
            var tp = to.position || {};
            if (fp.x !== undefined || tp.x !== undefined) 
                result.position.x = lerp(fp.x || 0, tp.x || 0, t);
            if (fp.y !== undefined || tp.y !== undefined) 
                result.position.y = lerp(fp.y || 0, tp.y || 0, t);
            if (fp.z !== undefined || tp.z !== undefined) 
                result.position.z = lerp(fp.z || 0, tp.z || 0, t);
        }
        
        if (from.rotation || to.rotation) {
            result.rotation = {};
            var fr = from.rotation || {};
            var tr = to.rotation || {};
            if (fr.x !== undefined || tr.x !== undefined) 
                result.rotation.x = lerp(fr.x || 0, tr.x || 0, t);
            if (fr.y !== undefined || tr.y !== undefined) 
                result.rotation.y = lerp(fr.y || 0, tr.y || 0, t);
            if (fr.z !== undefined || tr.z !== undefined) 
                result.rotation.z = lerp(fr.z || 0, tr.z || 0, t);
        }
        
        if (from.scale !== undefined || to.scale !== undefined) {
            var fs = from.scale;
            var ts = to.scale;
            // Handle uniform scale (number) or per-axis scale (object)
            if (typeof fs === 'number' || typeof ts === 'number') {
                result.scale = lerp(fs || 1, ts || 1, t);
            } else {
                result.scale = {};
                fs = fs || {};
                ts = ts || {};
                if (fs.x !== undefined || ts.x !== undefined)
                    result.scale.x = lerp(fs.x || 1, ts.x || 1, t);
                if (fs.y !== undefined || ts.y !== undefined)
                    result.scale.y = lerp(fs.y || 1, ts.y || 1, t);
                if (fs.z !== undefined || ts.z !== undefined)
                    result.scale.z = lerp(fs.z || 1, ts.z || 1, t);
            }
        }
        
        return result;
    }

    /**
     * Create a scroll-tied object transform animation
     * 
     * Options:
     *   id:        (string) Unique identifier
     *   container: (string|Element) Scroll container
     *   object:    (string) Spline object name
     *   start:     (number) Element progress start (0-1)
     *   end:       (number) Element progress end (0-1)
     *   easing:    (string) Easing function name
     *   
     *   // From/to transform:
     *   from: { position: {x,y,z}, rotation: {x,y,z}, scale: {x,y,z} or number }
     *   to:   { position: {x,y,z}, rotation: {x,y,z}, scale: {x,y,z} or number }
     *   
     *   // OR keyframes (at values > 1 extend the animation beyond the scroll container):
     *   keyframes: [
     *       { at: 0, position: {x,y,z}, rotation: {x,y,z}, scale: 1 },
     *       { at: 0.5, position: {x,y,z}, rotation: {x,y,z}, scale: 1.5 },
     *       { at: 1, position: {x,y,z}, rotation: {x,y,z}, scale: 2 },
     *       { at: 1.5, position: {x,y,z}, rotation: {x,y,z}, scale: 3 }
     *   ]
     */
    function scrollAnimateObject(opts) {
        if (!window.scrolltied) {
            console.warn('rtdSpline.scrollAnimateObject: scrolltied not initialized');
            return null;
        }

        var container = typeof opts.container === 'string' 
            ? document.querySelector(opts.container) 
            : opts.container;
        
        if (!container) {
            console.warn('rtdSpline.scrollAnimateObject: container not found', opts.container);
            return null;
        }

        var globalEasing = easings[opts.easing] || easings.linear;
        var lastProgress = null;

        var maxAt = 1;
        if (opts.keyframes) {
            for (var k = 0; k < opts.keyframes.length; k++) {
                if (opts.keyframes[k].at > maxAt) maxAt = opts.keyframes[k].at;
            }
        }
        var progressMax = maxAt * 100;

        var scroller = new Scroller({
            id: opts.id || 'rtd-obj-' + Math.random().toString(36).substr(2, 9),
            container: container,
            el_start: opts.start !== undefined ? opts.start : 0,
            el_end: opts.end !== undefined ? opts.end : 1,
            progress_max: progressMax,
            window_offset: opts.windowOffset !== undefined ? opts.windowOffset : 0.5,
            markers: opts.markers || false,

            onunstart: function() {
                applyAtProgress(0);
                if (opts.onunstart) opts.onunstart();
            },

            onstart: function() {
                applyAtProgress(0);
                if (opts.onstart) opts.onstart();
            },

            oncomplete: function() {
                applyAtProgress(progressMax);
                if (opts.onComplete) opts.onComplete();
            },

            onprogress: function(prog) {
                if (lastProgress === prog) return;
                lastProgress = prog;
                applyAtProgress(prog);
            }
        });

        function applyAtProgress(prog) {
            var normalizedProg = prog / progressMax;
            var easedProg = globalEasing(normalizedProg) * maxAt;
            var transform;

            if (opts.keyframes) {
                transform = keyframeLerpTransform(opts.keyframes, easedProg);
            } else if (opts.from && opts.to) {
                transform = lerpTransform(opts.from, opts.to, easedProg);
            }

            if (transform) {
                setTransform(opts.object, transform);
            }

            if (opts.onProgress) opts.onProgress(prog, transform);
        }

        // Keyframe interpolation for transforms
        function keyframeLerpTransform(keyframes, progress) {
            if (!keyframes || keyframes.length === 0) return {};
            if (keyframes.length === 1) {
                return {
                    position: keyframes[0].position,
                    rotation: keyframes[0].rotation,
                    scale: keyframes[0].scale
                };
            }
            
            // Find the two keyframes we're between
            for (var i = 0; i < keyframes.length - 1; i++) {
                var curr = keyframes[i];
                var next = keyframes[i + 1];
                if (progress >= curr.at && progress <= next.at) {
                    var segmentProgress = (progress - curr.at) / (next.at - curr.at);
                    return lerpTransform(
                        { position: curr.position, rotation: curr.rotation, scale: curr.scale },
                        { position: next.position, rotation: next.rotation, scale: next.scale },
                        segmentProgress
                    );
                }
            }
            
            // Outside range
            if (progress < keyframes[0].at) {
                var first = keyframes[0];
                return { position: first.position, rotation: first.rotation, scale: first.scale };
            }
            var last = keyframes[keyframes.length - 1];
            return { position: last.position, rotation: last.rotation, scale: last.scale };
        }

        window.scrolltied.add(scroller);
        return scroller;
    }

    /**
     * Animate object transform with anime.js (non-scroll)
     */
    function animateObject(objectName, opts) {
        if (typeof anime === 'undefined') {
            console.warn('rtdSpline.animateObject: anime.js not loaded');
            return null;
        }

        var target = { t: 0 };
        var fromTransform = opts.from || {};
        var toTransform = opts.to || {};
        
        return anime({
            targets: target,
            t: 1,
            duration: opts.duration || 1000,
            easing: opts.easing || 'easeInOutQuad',
            update: function() {
                var transform = lerpTransform(fromTransform, toTransform, target.t);
                setTransform(objectName, transform);
            },
            complete: opts.onComplete || null
        });
    }

    /**
     * Create a scroll-tied Spline animation
     * 
     * Options:
     *   id:        (string) Unique identifier for debugging
     *   container: (string|Element) Scroll container selector or element
     *   start:     (number) Element progress to start (0-1), default 0
     *   end:       (number) Element progress to end (0-1), default 1
     *   windowOffset: (number) Viewport offset, default 0.5
     *   easing:    (string) Global easing: 'linear', 'easeIn', 'easeOut', 'easeInOut'
     *   
     *   // Simple single variable:
     *   variable:  (string) Spline variable name
     *   from:      (number) Start value
     *   to:        (number) End value
     *   
     *   // OR keyframes for single variable (at values > 1 extend beyond the scroll container):
     *   variable:  (string) Spline variable name
     *   keyframes: [{at: 0, value: X}, {at: 0.5, value: Y}, {at: 1, value: Z}, {at: 1.5, value: W}]
     *   
     *   // OR multiple variables:
     *   variables: {
     *       'var_name': { from: X, to: Y },
     *       'var_name2': { from: A, to: B, easing: 'easeOut' },
     *       'var_name3': { keyframes: [...] }
     *   }
     *   
     *   // Callbacks:
     *   onStart:    function() - called when entering from before
     *   onComplete: function() - called when reaching end
     *   onProgress: function(progress, values) - called on every update
     */
    function scrollAnimate(opts) {
        if (!window.scrolltied) {
            console.warn('rtdSpline.scrollAnimate: scrolltied not initialized');
            return null;
        }

        var container = typeof opts.container === 'string' 
            ? document.querySelector(opts.container) 
            : opts.container;
        
        if (!container) {
            console.warn('rtdSpline.scrollAnimate: container not found', opts.container);
            return null;
        }

        var globalEasing = easings[opts.easing] || easings.linear;
        var lastProgress = null;

        var maxAt = 1;
        if (opts.keyframes) {
            for (var k = 0; k < opts.keyframes.length; k++) {
                if (opts.keyframes[k].at > maxAt) maxAt = opts.keyframes[k].at;
            }
        }
        if (opts.variables) {
            for (var vn in opts.variables) {
                var vkf = opts.variables[vn].keyframes;
                if (vkf) {
                    for (var k = 0; k < vkf.length; k++) {
                        if (vkf[k].at > maxAt) maxAt = vkf[k].at;
                    }
                }
            }
        }
        var progressMax = maxAt * 100;

        var scroller = new Scroller({
            id: opts.id || 'rtd-spline-' + Math.random().toString(36).substr(2, 9),
            container: container,
            el_start: opts.start !== undefined ? opts.start : 0,
            el_end: opts.end !== undefined ? opts.end : 1,
            progress_max: progressMax,
            window_offset: opts.windowOffset !== undefined ? opts.windowOffset : 0.5,
            markers: opts.markers || false,

            onunstart: function() {
                applyAtProgress(0);
                if (opts.onStart) opts.onStart();
            },

            oncomplete: function() {
                applyAtProgress(progressMax);
                if (opts.onComplete) opts.onComplete();
            },

            onprogress: function(prog) {
                if (lastProgress === prog) return;
                lastProgress = prog;

                applyAtProgress(prog);
            }
        });

        function applyAtProgress(prog) {
            var normalizedProg = prog / progressMax;
            var easedProg = globalEasing(normalizedProg) * maxAt;
            var values = {};

            // Single variable mode
            if (opts.variable) {
                var val;
                if (opts.keyframes) {
                    val = keyframeLerp(opts.keyframes, easedProg);
                } else {
                    val = lerp(opts.from || 0, opts.to || 0, easedProg);
                }
                setVar(opts.variable, val);
                values[opts.variable] = val;
            }

            // Multiple variables mode
            if (opts.variables) {
                var varsToSet = {};
                for (var varName in opts.variables) {
                    var varOpts = opts.variables[varName];
                    var varEasing = varOpts.easing ? easings[varOpts.easing] : globalEasing;
                    var varEasedProg = varEasing(normalizedProg) * maxAt;
                    var varVal;

                    if (varOpts.keyframes) {
                        varVal = keyframeLerp(varOpts.keyframes, varEasedProg);
                    } else {
                        varVal = lerp(varOpts.from || 0, varOpts.to || 0, varEasedProg);
                    }
                    varsToSet[varName] = varVal;
                    values[varName] = varVal;
                }
                setVars(varsToSet);
            }

            if (opts.onProgress) opts.onProgress(prog, values);
        }

        window.scrolltied.add(scroller);
        return scroller;
    }

    /**
     * Animate a Spline variable with anime.js (for non-scroll animations)
     * Returns the anime instance for control
     */
    function animate(variable, opts) {
        if (typeof anime === 'undefined') {
            console.warn('rtdSpline.animate: anime.js not loaded');
            return null;
        }

        var target = { value: opts.from || 0 };
        
        return anime({
            targets: target,
            value: opts.to || 0,
            duration: opts.duration || 1000,
            easing: opts.easing || 'easeInOutQuad',
            update: function() {
                setVar(variable, target.value);
            },
            complete: opts.onComplete || null
        });
    }

    // Public API
    return {
        // Variables
        setVar: setVar,
        setVars: setVars,
        scrollAnimate: scrollAnimate,
        animate: animate,
        
        // Object transforms
        getObject: getObject,
        clearObjectCache: clearObjectCache,
        setPosition: setPosition,
        setRotation: setRotation,
        setScale: setScale,
        setTransform: setTransform,
        scrollAnimateObject: scrollAnimateObject,
        animateObject: animateObject,
        
        // Utilities
        easings: easings,
        lerp: lerp,
        keyframeLerp: keyframeLerp,
        lerpTransform: lerpTransform
    };

})();


// ============================================
// Responsive Scroll Animation System
// ============================================
// Two fully independent animation sets: desktop (>= 800px) and mobile (< 800px).
// - setupDesktopScrollAnims(): all scroll animations for desktop
// - setupMobileScrollAnims(): all scroll animations for mobile (customize freely)
// - initScrollAnims(): picks the right set based on window.innerWidth
// - Automatically tears down & rebuilds when crossing the 800px breakpoint on resize.
// ============================================

var _rtdAnimIds = [];
var _rtdCurrentBreakpoint = null;

function _trackScrollAnim(scroller) {
    if (scroller && scroller.id) _rtdAnimIds.push(scroller.id);
    return scroller;
}

function _addTrackedScroller(opts) {
    var scroller = new Scroller(opts);
    window.scrolltied.add(scroller);
    _rtdAnimIds.push(opts.id);
    return scroller;
}

function teardownScrollAnims() {
    for (var i = 0; i < _rtdAnimIds.length; i++) {
        window.scrolltied.remove(_rtdAnimIds[i]);
    }
    _rtdAnimIds = [];
}

function initScrollAnims() {
    var bp = window.innerWidth < 800 ? 'mobile' : 'desktop';
    if (bp === _rtdCurrentBreakpoint) return;
    teardownScrollAnims();
    _rtdCurrentBreakpoint = bp;
    if (bp === 'mobile') {
        setupMobileScrollAnims();
    } else {
        setupDesktopScrollAnims();
    }
}

// ============================================
// DESKTOP Scroll Animations (>= 800px)
// ============================================
function setupDesktopScrollAnims() {

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-upwards-1',
        container: '.hero',
        object: "Ube_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: 0 }, rotation: { y: 0 } },
            { at: 1, position: { y: 250 }, rotation: { y: Math.PI } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-upwards-2',
        container: '.hero',
        object: "Matcha_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: 0 }, rotation: { y: 0 } },
            { at: 1, position: { y: 250 }, rotation: { y: Math.PI } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-upwards-3',
        container: '.hero',
        object: "Chai_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: 0 }, rotation: { y: 0 } },
            { at: 1, position: { y: 250 }, rotation: { y: Math.PI } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-upwards-4',
        container: '.hero',
        object: "Mocha_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: 0 }, rotation: { y: 0 } },
            { at: 1, position: { y: 350 }, rotation: { y: Math.PI } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-fall-30',
        container: '.hero',
        object: "OD_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0.1, rotation: { z: 0 }, position: {y: 0} },
            { at: 1.25, rotation: { z: -Math.PI/6 }, position: {y: -20} },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-quick-360',
        container: '.quality',
        object: "OD_Inner",
        windowOffset: 0,
        markers: true,
        easing: 'easeInOut',
        onstart: function(){
            document.querySelector(".quality").classList.add("active")
            document.querySelector("main").classList.add("no-bis")
        },
        onunstart: function(){
            document.querySelector(".quality").classList.remove("active")
            document.querySelector("main").classList.remove("no-bis")
            window.transition_texture(window._rtdSelectedFlavor || "od")
        },
        keyframes: [
            { at: 0, rotation: { y: 0 } },
            { at: 0.8, rotation: { y: Math.PI*2  } },
        ]
    }));

    var dropletEl = document.getElementById('rtd-droplet-rising');
    if (dropletEl) {
        _addTrackedScroller({
            id: 'droplet-rising',
            container: document.querySelector('.quality'),
            window_offset: 0,
            el_start: 0.1,
            el_end: 0.66,
            markers: true,
            onunstart: function() {
                dropletEl.style.transform = 'translateY(0px)';
            },
            oncomplete: function() {
                dropletEl.style.transform = 'translateY(-111px)';
            },
            onprogress: function(prog) {
                var y = -111 * (prog / 100);
                dropletEl.style.transform = 'translateY(' + y + 'px)';
            }
        });
    }

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-up-30',
        container: '.lineup',
        object: "OD_Outer",
        windowOffset: 1,
        markers: true,
        easing: 'easeInOut',
        keyframes: [
            { at: 0, rotation: { y: 0 } },
            { at: 1, rotation: { y: Math.PI* 2}  },
        ]
    }));

    var exploreHR = document.querySelector('.explore hr');
    if (exploreHR) {
        _addTrackedScroller({
            id: 'hr-draw',
            container: document.querySelector('.lineup'),
            window_offset: 0,
            easing: "easeLinear",
            el_start: 0.0,
            el_end: 0.5,
            markers: true,
            onunstart: function() {
                exploreHR.style.width = '0%';
            },
            oncomplete: function() {
                exploreHR.style.width = '100%';
            },
            onprogress: function(prog) {
                exploreHR.style.width = prog + '%';
            }
        });
    }

    _addTrackedScroller({
        id: 'lineup-intro-class',
        container: document.querySelector('.lineup'),
        window_offset: 0.1,
        el_start: 0,
        el_end: 0.1,
        markers: true,
        targets:[document.querySelector(".lineup")],
        classes: ["active"],
        stickClass: false
    });

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-unlineup-30',
        container: '.lineup',
        object: "OD_Page",
        windowOffset: 1,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, rotation: { z: -Math.PI/6 }},
            { at: 1, rotation: { z: 0 } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-stats-front',
        container: '.stats',
        object: "OD_Page",
        windowOffset: 0,
        markers: true,
        easing: 'linear',
        keyframes: [
            { at: 0, rotation: {z: 0}},
            { at: 0.5, rotation: {z: -2*Math.PI}},
        ]
    }));

    var drawCircle = document.getElementById('drawme-circle');
    if (drawCircle) {
        var pathLen = drawCircle.getTotalLength();
        drawCircle.style.strokeDasharray = pathLen;
        drawCircle.style.strokeDashoffset = pathLen;
        _addTrackedScroller({
            id: 'drawme-circle',
            container: document.querySelector('.stats'),
            window_offset: 0,
            easing: "linear",
            el_start: 0,
            markers: true,
            el_end: 0.5,
            onunstart: function() {
                drawCircle.style.strokeDashoffset = pathLen;
            },
            oncomplete: function() {
                drawCircle.style.strokeDashoffset = 0;
            },
            onprogress: function(prog) {
                drawCircle.style.strokeDashoffset = pathLen - (pathLen * prog / 100);
            }
        });

        var statRevealConfig = [
            { id: 'stat-1', showAt: 87  },
            { id: 'stat-2', showAt: 75 },
            { id: 'stat-3', showAt: 63 },
            { id: 'stat-6', showAt: 37 },
            { id: 'stat-5', showAt: 25 },
            { id: 'stat-4', showAt: 13 },
        ];

        statRevealConfig.forEach(function(cfg) {
            var el = document.getElementById(cfg.id);
            if (!el) return;
            el.style.opacity = '0';
            el.style.transition = 'opacity 0.2s ease';
        });

        _addTrackedScroller({
            id: 'stat-reveals',
            container: document.querySelector('.stats'),
            window_offset: 0,
            el_start: 0,
            el_end: 0.5,
            onunstart: function() {
                statRevealConfig.forEach(function(cfg) {
                    var el = document.getElementById(cfg.id);
                    if (el) el.style.opacity = '0';
                });
            },
            oncomplete: function() {
                statRevealConfig.forEach(function(cfg) {
                    var el = document.getElementById(cfg.id);
                    if (el) el.style.opacity = '1';
                });
            },
            onprogress: function(prog) {
                statRevealConfig.forEach(function(cfg) {
                    var el = document.getElementById(cfg.id);
                    if (!el) return;
                    el.style.opacity = prog >= cfg.showAt ? '1' : '0';
                });
            }
        });
    }

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-outtahere',
        container: '.eyes',
        object: "OD_Page",
        windowOffset: 1,
        markers: true,
        easing: 'linear',
        keyframes: [
            { at: 0, position: {y: -20}, rotation: {y: 0}},
            { at: 1.5, position: {y: 250}, rotation: {y: Math.PI}},
        ]
    }));

    window.scrub_video = document.getElementById('the-video');
    var vidContainer = document.querySelector(".retailers");

    _addTrackedScroller({
        id: 'video-play',
        container: vidContainer,
        window_offset: 0.1,
        el_start: 0,
        el_end: 0.5,
        markers: true,
        onunstart: function() {
            if (window.scrub_video.readyState >= 4) 
            {
                window.scrub_video.currentTime = 0;
            }
        },
        oncomplete: function() {
            if (window.scrub_video.readyState >= 4) window.scrub_video.currentTime = window.scrub_video.duration;
        },
        onprogress: function(prog) {
            if (window.scrub_video.readyState >= 4) window.scrub_video.currentTime = (prog / 100) * window.scrub_video.duration;
        }
    });

}

// ============================================
// MOBILE Scroll Animations (< 800px)
// ============================================
// Fully independent from desktop. Customize any/all animations below.
// Uses the same helpers: _trackScrollAnim() and _addTrackedScroller().
function setupMobileScrollAnims() {

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-upwards-1',
        container: '.hero',
        object: "Ube_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: 0 }, rotation: { y: 0 } },
            { at: 1, position: { y: 250 }, rotation: { y: Math.PI } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-upwards-2',
        container: '.hero',
        object: "Matcha_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: 0 }, rotation: { y: 0 } },
            { at: 1, position: { y: 250 }, rotation: { y: Math.PI } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-upwards-3',
        container: '.hero',
        object: "Chai_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: 0 }, rotation: { y: 0 } },
            { at: 1, position: { y: 250 }, rotation: { y: Math.PI } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-upwards-4',
        container: '.hero',
        object: "Mocha_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: 0 }, rotation: { y: 0 } },
            { at: 1, position: { y: 450 }, rotation: { y: Math.PI } },
        ]
    }));



    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-fall-30',
        container: '.hero',
        object: "OD_Page",
        windowOffset: 0,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0.1, rotation: { z: 0 }, position: {y: 0} },
            { at: 1.25, rotation: { z: -Math.PI/6 }, position: {y: -20} },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-quick-360',
        container: '.quality',
        object: "OD_Inner",
        windowOffset: 0,
        markers: true,
        easing: 'easeInOut',
        onstart: function(){
            document.querySelector(".quality").classList.add("active")
        },
        onunstart: function(){
            document.querySelector(".quality").classList.remove("active")
            window.transition_texture(window._rtdSelectedFlavor || "od")
        },
        keyframes: [
            { at: 0, rotation: { y: 0 } },
            { at: 0.4, rotation: { y: Math.PI*2  } },
        ]
    }));

    var dropletEl = document.getElementById('rtd-droplet-rising');
    if (dropletEl) {
        _addTrackedScroller({
            id: 'droplet-rising',
            container: document.querySelector('.quality'),
            window_offset: 0,
            el_start: 0.0,
            el_end: 0.4,
            markers: true,
            onunstart: function() {
                dropletEl.style.transform = 'translateY(0px)';
            },
            oncomplete: function() {
                dropletEl.style.transform = 'translateY(-111px)';
            },
            onprogress: function(prog) {
                var y = -111 * (prog / 100);
                dropletEl.style.transform = 'translateY(' + y + 'px)';
            }
        });
    }

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-up-30',
        container: '.lineup',
        object: "OD_Outer",
        windowOffset: 1,
        markers: true,
        easing: 'easeInOut',
        keyframes: [
            { at: 0, rotation: { y: 0 } },
            { at: 1, rotation: { y: Math.PI* 2}  },
        ]
    }));

    var exploreHR = document.querySelector('.explore hr');
    if (exploreHR) {
        _addTrackedScroller({
            id: 'hr-draw',
            container: document.querySelector('.lineup'),
            window_offset: 0,
            easing: "easeLinear",
            el_start: 0.0,
            el_end: 0.5,
            markers: true,
            onunstart: function() {
                exploreHR.style.width = '0%';
            },
            oncomplete: function() {
                exploreHR.style.width = '100%';
            },
            onprogress: function(prog) {
                exploreHR.style.width = prog + '%';
            }
        });
    }

    _addTrackedScroller({
        id: 'lineup-intro-class',
        container: document.querySelector('.lineup'),
        window_offset: 0.1,
        el_start: 0,
        el_end: 0.1,
        markers: true,
        targets:[document.querySelector(".lineup")],
        classes: ["active"],
        stickClass: false
    });

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-unlineup-30',
        container: '.lineup',
        object: "OD_Page",
        windowOffset: 1,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, rotation: { z: -Math.PI/6 }},
            { at: 1, rotation: { z: 0 } },
        ]
    }));

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-stats-front',
        container: '.stats',
        object: "OD_Page",
        windowOffset: 0,
        markers: true,
        easing: 'linear',
        keyframes: [
            { at: 0, rotation: {z: 0}},
            { at: 0.5, rotation: {z: -2*Math.PI}},
        ]
    }));



    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-unlineup-30',
        container: '.lineup',
        object: "OD_Page",
        windowOffset: 1,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, rotation: { z: -Math.PI/6 }},
            { at: 1, rotation: { z: 0 } },
        ]
    }));


    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-go-down-for-stats',
        container: '.stats',
        object: "OD_Page",
        windowOffset: 1,
        markers: true,
        easing: 'easeIn',
        keyframes: [
            { at: 0, position: { y: -20, z: 0}},
            { at: 0.05, position: { y: -80, z: 200 } },
        ]
    }));


    var drawCircle = document.querySelector(".stats .mobile-only svg")
    if (drawCircle) {


        _addTrackedScroller({
            id: 'drawme-circle',
            container: document.querySelector('.stats'),
            window_offset: 0,
            easing: "linear",
            el_start: 0,
            markers: true,
            el_end: 0.5,
            onunstart: function() {
                drawCircle.style.setProperty('--current-rotation', '0');
            },
            oncomplete: function() {
                drawCircle.style.setProperty('--current-rotation', '150');
            },
            onprogress: function(prog) {
                var deg = (150 * prog / 100);
                drawCircle.style.setProperty('--current-rotation', deg);
            }
        });


    }

    _trackScrollAnim(rtdSpline.scrollAnimateObject({
        id: 'can-outtahere',
        container: '.eyes',
        object: "OD_Page",
        windowOffset: 1,
        markers: true,
        easing: 'linear',
        keyframes: [
            { at: 0, position: {y: -80}, rotation: {y: 0}},
            { at: 1.5, position: {y: 250}, rotation: {y: Math.PI}},
        ]
    }));

    window.scrub_video = document.getElementById('the-video');
    var vidContainer = document.querySelector(".retailers");

    _addTrackedScroller({
        id: 'video-play',
        container: vidContainer,
        window_offset: 0.1,
        el_start: 0,
        el_end: 0.5,
        markers: true,
        onunstart: function() {
            if (window.scrub_video.readyState >= 4) 
            {
                window.scrub_video.currentTime = 0;
            }
        },
        oncomplete: function() {
            if (window.scrub_video.readyState >= 4) window.scrub_video.currentTime = window.scrub_video.duration;
        },
        onprogress: function(prog) {
            if (window.scrub_video.readyState >= 4) window.scrub_video.currentTime = (prog / 100) * window.scrub_video.duration;
        }
    });


    var statsSection = document.querySelector('.stats');
    if (statsSection) {
        _addTrackedScroller({
            id: 'stats-zindex',
            container: statsSection,
            window_offset: 0,
            easing: "linear",
            el_start: 0,
            el_end: 0.01,
            markers: true,
            onunstart: function() {
                statsSection.classList.remove('active');
            },
            onprogress: function() {
                statsSection.classList.add('active');
            },
            oncomplete: function() {
                statsSection.classList.add('active');
            }
        });
    }
}


$(function(){

    window.scrolltied = new ScrollTide({nomarkers: true});
    setup_misc_click_handlers()

    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const lenis = new Lenis({
        autoRaf: true,
        wheelMultiplier: isTouchDevice ? 1 : 0.4,
        touchMultiplier: 1.5,
        allowNestedScroll: true
    });


    // Initialize scroll animations for current breakpoint
    initScrollAnims();

    // Re-initialize when crossing the 800px mobile breakpoint
    var _resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(_resizeTimer);
        _resizeTimer = setTimeout(function() {
            var newBp = window.innerWidth < 800 ? 'mobile' : 'desktop';
            if (newBp !== _rtdCurrentBreakpoint) {
                initScrollAnims();
                scrolltied.start();
            }
        }, 200);
    });

    scrolltied.start()
    scrolltied.update()

    // ========================================
    // SPLINE SCROLL ANIMATIONS
    // ========================================
    // Use rtdSpline.scrollAnimate() to tie Spline variables to scroll position.
    // These will only work after Spline is loaded, so wrap in rtdOnAllLoaded() 
    // or check window.rtdLoadState.splineReady first.
    //
    // EXAMPLES:
    //
    // Simple from/to animation:
    // rtdSpline.scrollAnimate({
    //     id: 'hero-zoom',
    //     container: '.hero',
    //     variable: 'camera_zoom',
    //     from: 0,
    //     to: 100,
    //     start: 0,      // start at 0% of element
    //     end: 1,        // end at 100% of element
    //     easing: 'easeInOut'
    // });
    //
    // Keyframe animation (multiple stops):
    // rtdSpline.scrollAnimate({
    //     id: 'rotation-keyframes',
    //     container: '.quality',
    //     variable: 'can_rotation',
    //     keyframes: [
    //         { at: 0, value: 0 },
    //         { at: 0.3, value: 45 },
    //         { at: 0.7, value: 90 },
    //         { at: 1, value: 180 }
    //     ]
    // });
    //
    // Multiple variables at once:
    // rtdSpline.scrollAnimate({
    //     id: 'camera-move',
    //     container: '.lineup',
    //     variables: {
    //         'camera_x': { from: 0, to: 500 },
    //         'camera_y': { from: 100, to: -100 },
    //         'opacity': { from: 100, to: 0, easing: 'easeOut' }
    //     }
    // });
    //
    // With callbacks:
    // rtdSpline.scrollAnimate({
    //     id: 'with-callbacks',
    //     container: '.stats',
    //     variable: 'explode',
    //     from: 0,
    //     to: 100,
    //     onStart: function() { console.log('Animation starting'); },
    //     onComplete: function() { console.log('Animation complete'); },
    //     onProgress: function(prog, values) { console.log(prog, values); }
    // });
    //
    // Direct variable set (no scroll):
    // rtdSpline.setVar('some_var', 50);
    // rtdSpline.setVars({ var1: 10, var2: 20 });
    //
    // Anime.js animation (non-scroll):
    // rtdSpline.animate('zoom', { from: 0, to: 100, duration: 1000, easing: 'easeOutQuad' });
    //
    // ========================================
    // OBJECT TRANSFORM ANIMATIONS
    // ========================================
    //
    // Scroll-animate object position/rotation/scale:
    // rtdSpline.scrollAnimateObject({
    //     id: 'can-move',
    //     container: '.hero',
    //     object: 'Can',  // Spline object name
    //     from: {
    //         position: { x: 0, y: 0, z: 0 },
    //         rotation: { x: 0, y: 0, z: 0 },
    //         scale: 1
    //     },
    //     to: {
    //         position: { x: 100, y: 50, z: -200 },
    //         rotation: { x: 0, y: Math.PI, z: 0 },
    //         scale: 1.5
    //     },
    //     easing: 'easeInOut'
    // });
    //
    // Keyframe object animation:
    // rtdSpline.scrollAnimateObject({
    //     id: 'can-keyframes',
    //     container: '.quality',
    //     object: 'Can',
    //     keyframes: [
    //         { at: 0, position: { y: 0 }, rotation: { y: 0 } },
    //         { at: 0.5, position: { y: 100 }, rotation: { y: Math.PI } },
    //         { at: 1, position: { y: 0 }, rotation: { y: Math.PI * 2 } }
    //     ]
    // });
    //
    // Direct object transforms (no scroll):
    // rtdSpline.setPosition('Can', { x: 10, y: 20, z: 30 });
    // rtdSpline.setRotation('Can', { x: 0, y: Math.PI / 2, z: 0 });
    // rtdSpline.setScale('Can', 2);  // uniform scale
    // rtdSpline.setScale('Can', { x: 1, y: 2, z: 1 });  // per-axis
    // rtdSpline.setTransform('Can', { position: {...}, rotation: {...}, scale: {...} });
    //
    // Anime.js object animation (non-scroll):
    // rtdSpline.animateObject('Can', {
    //     from: { position: { y: 0 }, scale: 1 },
    //     to: { position: { y: 100 }, scale: 2 },
    //     duration: 1000,
    //     easing: 'easeOutQuad'
    // });
    //
    // Get object reference for custom manipulation:
    // var can = rtdSpline.getObject('Can');
    // if (can) { can.visible = false; }
    // ========================================

    // setup_scrollties()

    // setup_feat_prod_swiper()




    window.atc_clicks = 0;



    
    // Seed-to-can videos: defer loading until section is near viewport
    var s2cSection = document.querySelector('.seed2can');
    if (s2cSection) {
        var s2cObserver = new IntersectionObserver(function(entries) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    s2cObserver.unobserve(s2cSection);
                    s2cSection.querySelectorAll('video[data-src]').forEach(function(vid) {
                        vid.src = vid.getAttribute('data-src');
                        vid.removeAttribute('data-src');
                        vid.load();
                    });
                    break;
                }
            }
        }, { rootMargin: '20% 0px' });
        s2cObserver.observe(s2cSection);
    }

    // Seed-to-can tiles: play on hover, pause on leave; click opens modal
    document.querySelectorAll('.s2c-tile').forEach(function(tile) {
        var vid = tile.querySelector('video');
        if (vid) {
            tile.addEventListener('mouseenter', function() { vid.play(); });
            tile.addEventListener('mouseleave', function() { vid.pause(); });
        }
        var modalId = tile.getAttribute('data-modal');
        if (modalId) {
            tile.style.cursor = 'pointer';
            tile.addEventListener('click', function() {
                $(".coffee-modal.active").removeClass("active");
                $("#" + modalId).addClass("active");
            });
        }
    });

    // Nutrition Facts buttons open per-flavor modals
    document.querySelectorAll('.lineup-detail .nutrition[data-modal]').forEach(function(btn) {
        btn.addEventListener('click', function() {
            var modalId = btn.getAttribute('data-modal');
            if (modalId) {
                $(".coffee-modal.active").removeClass("active");
                $("#" + modalId).addClass("active");
            }
        });
    });

    // ---- Find in Store ----
    (function(){
        var RETAILERS_URL = 'https://product.onyxcontent.com/rtd/retailers.json';
        var DEEP_LINK_PARAM = 'find-in-store';
        var MAX_RESULTS = 25;   // cap for text searches
        var NEAR_COUNT = 10;    // how many to show for "near me"

        var data = null;          // null until loaded
        var loadPromise = null;
        var userLoc = null;       // { lat, lng } once geolocated

        var $btn = $('.global-atc .retailers-btn');
        var $modal = $('#find-in-store');
        if (!$modal.length) return;

        var $list = $modal.find('.fis-list');
        var $search = $modal.find('.fis-search');
        var $locate = $modal.find('.fis-locate');
        var $status = $modal.find('.fis-status');

        function esc(s){ return $('<div>').text(s == null ? '' : s).html(); }

        function distanceMiles(a, b){
            var R = 3958.8, rad = Math.PI / 180;
            var dLat = (b.lat - a.lat) * rad;
            var dLng = (b.lng - a.lng) * rad;
            var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.sin(dLng / 2) * Math.sin(dLng / 2) *
                Math.cos(a.lat * rad) * Math.cos(b.lat * rad);
            return 2 * R * Math.asin(Math.sqrt(h));
        }

        function byDist(a, b){
            return (a._dist == null ? Infinity : a._dist) - (b._dist == null ? Infinity : b._dist);
        }

        function computeDistances(){
            if (!userLoc || !data) return;
            data.forEach(function(r){
                r._dist = (typeof r.lat === 'number' && typeof r.lng === 'number')
                    ? distanceMiles(userLoc, r) : null;
            });
        }

        function itemHtml(r){
            var a = r.address || {};
            var street = [a.line_1, a.line_2].filter(Boolean).join(', ');
            var cityline = [a.city, a.state].filter(Boolean).join(', ');
            if (a.zipcode) cityline += ' ' + a.zipcode;
            var mapsQuery = encodeURIComponent([r.title, street, cityline].filter(Boolean).join(', '));

            var out = '<div class="fis-item" role="listitem">';
            out += '<div class="fis-item-head"><h3>' + esc(r.title) + '</h3>';
            if (typeof r._dist === 'number') out += '<span class="fis-dist">' + r._dist.toFixed(1) + ' mi</span>';
            out += '</div>';
            if (street) out += '<p class="fis-addr">' + esc(street) + '</p>';
            if (cityline) out += '<p class="fis-addr">' + esc(cityline) + '</p>';
            out += '<div class="fis-links">';
            out += '<a href="https://www.google.com/maps/search/?api=1&query=' + mapsQuery + '" target="_blank" rel="noopener">Directions</a>';
            if (r.website) out += '<a href="' + esc(r.website) + '" target="_blank" rel="noopener">Website</a>';
            out += '</div></div>';
            return out;
        }

        function showHint(msg){ $list.html('<p class="fis-hint">' + esc(msg) + '</p>'); }

        function renderItems(items){
            if (!items.length) { showHint('No stores match your search.'); return; }
            $list.html(items.map(itemHtml).join(''));
        }

        function showNearest(){
            if (!data || !userLoc) return;
            computeDistances();
            var sorted = data.filter(function(r){ return r._dist != null; }).sort(byDist);
            renderItems(sorted.slice(0, NEAR_COUNT));
            $status.text(sorted.length
                ? 'Showing the ' + Math.min(NEAR_COUNT, sorted.length) + ' closest locations.'
                : '');
        }

        function search(){
            if (!data) return;
            var q = ($search.val() || '').toLowerCase().trim();
            if (!q) {
                // Never dump the full list: prompt, or show nearest if located.
                if (userLoc) { showNearest(); }
                else {
                    $status.text('');
                    showHint('Search by city, state, or zip \u2014 or tap \u201CNear me\u201D to find the closest stores.');
                }
                return;
            }
            var matches = data.filter(function(r){
                var a = r.address || {};
                var hay = [r.title, a.line_1, a.line_2, a.city, a.state, a.zipcode]
                    .filter(Boolean).join(' ').toLowerCase();
                return hay.indexOf(q) !== -1;
            });
            if (userLoc) matches.sort(byDist);
            var extra = matches.length - MAX_RESULTS;
            renderItems(matches.slice(0, MAX_RESULTS));
            $status.text(extra > 0
                ? extra + ' more result' + (extra > 1 ? 's' : '') + ' \u2014 refine your search to narrow down.'
                : '');
        }

        function load(){
            if (loadPromise) return loadPromise;
            $status.text('Loading stores\u2026');
            loadPromise = fetch(RETAILERS_URL, { cache: 'no-cache' })
                .then(function(res){ if (!res.ok) throw new Error('bad response'); return res.json(); })
                .then(function(json){
                    data = (json && json.retailers) || [];
                    $status.text('');
                })
                .catch(function(err){
                    loadPromise = null; // allow retry
                    throw err;
                });
            return loadPromise;
        }

        function openFindInStore(){
            $('.coffee-modal.active').removeClass('active');
            $modal.addClass('active');
            $('html').addClass('stuck');
            load().then(search).catch(function(){
                $status.text('');
                showHint('Sorry, we couldn\'t load store locations right now. Please try again later.');
            });
        }

        $btn.on('click', openFindInStore);

        var deepLinkParams = new URLSearchParams(window.location.search);
        var deepLinkValue = (deepLinkParams.get(DEEP_LINK_PARAM) || '').toLowerCase();
        if (deepLinkParams.has(DEEP_LINK_PARAM) &&
            (deepLinkValue === '' || deepLinkValue === '1' || deepLinkValue === 'true')) {
            openFindInStore();
        }

        $search.on('input', function(){ if (data) search(); });

        $locate.on('click', function(){
            if (!navigator.geolocation) {
                $status.text('Location isn\u2019t supported on this device. Try searching instead.');
                return;
            }
            $locate.addClass('loading').prop('disabled', true);
            $status.text('Getting your location\u2026');
            navigator.geolocation.getCurrentPosition(function(pos){
                userLoc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
                $locate.removeClass('loading').prop('disabled', false);
                $search.val('');
                load().then(showNearest).catch(function(){
                    $status.text('');
                    showHint('Sorry, we couldn\'t load store locations right now. Please try again later.');
                });
            }, function(err){
                $locate.removeClass('loading').prop('disabled', false);
                $status.text(err && err.code === 1
                    ? 'Location access was denied. Try searching instead.'
                    : 'Couldn\u2019t get your location. Try searching instead.');
            }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
        });
    })();

    // Mark DOM as ready and check if all loaded
    window.rtdLoadState.domReady = true;
    rtdCheckAllLoaded();
    
})




function setup_misc_click_handlers(){





    $(".lineup .color-selector").click(function(){
        var name = $(this).attr("data-name")
        window.rtdApplyFlavor(name)
        rtdSyncVariantToFlavor(name)
    })

    // When a flavor is picked on the page, select the matching purchase
    // variant (if one exists) so the ATC bar stays consistent
    function rtdSyncVariantToFlavor(name) {
        if (typeof product === "undefined" || !product.variants || typeof variant_changed !== "function") return;
        if (window.rtdFlavorFromVariant(window.selected_variant) === name) return;

        var match = null;
        for (var i = 0; i < product.variants.length; i++) {
            var v = product.variants[i];
            if (window.rtdFlavorFromVariant(v) !== name) continue;
            if (!match || (v.available && !match.available)) match = v;
        }
        if (!match) return;

        $("#variant-select").val(String(match.id));
        $("#variant-select-mobile").val(String(match.id));
        variant_changed();
    }
    



    // State object for blob rotation animations
    window.blob_rot_state = {
        currentValue: 0,
        animeInstance: null,
        isAnimatingFromButton: false, // Flag to prevent progress event interference
        isUserDragging: false // Track when user is actively touching/dragging
    };

    window.deets_swiper = new Swiper('.deets-slider', {
      slidesPerView: 1,
        loop: false,
        spaceBetween: 20,
        speed: 400,
      
      on: {
        slideChange: function() {
          // Update .caff-sel state to match the active slide
          var activeIndex = this.realIndex; // Use realIndex for looped swipers
          $(".caff-sel").attr("data-hov", "hov-" + activeIndex);
        },
        
        // ========================================
        // SWIPER ANIMATION HOOKS
        // Use these to lerp/animate other elements during swipe
        // ========================================
        touchStart: function(swiper, event) {
            // User started touching - pause any animations and mark as dragging
            if (window.blob_rot_state) {
                if (window.blob_rot_state.animeInstance) {
                    window.blob_rot_state.animeInstance.pause();
                }
                window.blob_rot_state.isAnimatingFromButton = false;
                window.blob_rot_state.isUserDragging = true;
            }
        },
        
        touchEnd: function(swiper, event) {
            // User released touch - no longer dragging
            if (window.blob_rot_state) {
                window.blob_rot_state.isUserDragging = false;
            }
        },
        
        transitionStart: function(swiper) {
            // Transition started - lerp from current position to target
            // Only animate if NOT already animating from button
            if (window.blob_rot_state && !window.blob_rot_state.isAnimatingFromButton && typeof anime !== "undefined") {
                // Calculate target blob_rot based on target slide
                var targetIndex = swiper.activeIndex;
                var totalSlides = swiper.slides.length;
                var targetProgress = totalSlides > 1 ? targetIndex / (totalSlides - 1) : 0;
                var targetBlobRot = -288 * targetProgress;
                
                // Cancel any existing animation
                if (window.blob_rot_state.animeInstance) {
                    window.blob_rot_state.animeInstance.pause();
                }
                
                // Animate from CURRENT position to target
                window.blob_rot_state.animeInstance = anime({
                    targets: window.blob_rot_state,
                    currentValue: targetBlobRot,
                    duration: swiper.params.speed || 400,
                    easing: 'easeOutCubic',
                    update: function() {
                        queueSpline(function(){
                            window.splineblob.setVariable("blob_rot", window.blob_rot_state.currentValue);
                        });
                    }
                });
            }
        },
        
        setTranslate: function(swiper,translate){

        },
        progress: function(swiper, progress) {
            // Only update during actual user dragging (not during animations)
            if (!window.blob_rot_state) return;
            
            // Skip if animating from button click
            if (window.blob_rot_state.isAnimatingFromButton) return;
            
            // Skip if NOT dragging (means we're in momentum/transition)
            if (!window.blob_rot_state.isUserDragging) return;
            
            var mapped_prog = -288 * progress
            
            // Update state and spline during drag
            window.blob_rot_state.currentValue = mapped_prog;

            queueSpline(function(){
                window.splineblob.setVariable("blob_rot", mapped_prog)
            })

        }
      }

    });



    



    // ATC - desktop (non-subscribe)
    $(".atc-button.desktop-only").click(function(){
        var that = $(this)
        if (that.data("adding") || !window.selected_variant || !window.selected_variant.id || !window.selected_variant.available) return

        window.atc_clicks++
        var already_did = that.data("added") === true
        var id = window.selected_variant.id
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1

        that.data("adding", true).html("Going...")

        CartJS.addItem(id, qty, {}, {
            "success": function(line_item){
                if (typeof show_cart_confirm === "function") show_cart_confirm(line_item)
                $("header .cart-count").show()
                that.data("adding", false).data("added", true)
                that.html(already_did ? "Again, again!!" : "You did it!")
            },
            "error": function(e){
                console.log(e)
                that.data("adding", false).html("Error :(")
            }
        })
    })

    // ATC - mobile (dual mode both one-time and subscription)
    $(".atc-button.mobile-only").click(function(){
        var that = $(this)
        if (that.data("adding") || !window.selected_variant || !window.selected_variant.id || !window.selected_variant.available) return

        var selected_subscription = $("#subscribe-selector-mobile").find(":selected")
        var freq_num = selected_subscription.val()
        var atc_options = {}

        if (freq_num != "one-time"){
            var sub_id = parseInt(selected_subscription.attr("data-id"), 10)
            if (!freq_num || isNaN(sub_id)) {
                that.html("Select a plan")
                return
            }

            atc_options = {
                shipping_interval_frequency: freq_num,
                selling_plan: sub_id
            }
        }

        var id = window.selected_variant.id
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1

        that.data("adding", true).html("Going...")

        CartJS.addItem(id, qty, atc_options, {
            "success": function(line_item){
                if (typeof show_cart_confirm === "function") show_cart_confirm(line_item)
                $("header .cart-count").show()
                that.data("adding", false).html("Added!")
            },
            "error": function(e){
                console.log(e)
                that.data("adding", false).html("Error :(")
            }
        })
    })

    $(".trans-learn-more").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    // Info icons in advanced options (metabolism / extraction)
    $(".info-icon").on("click", function(){
        var modalId = $(this).attr("data-modal");
        if (!modalId) return;
        $(".coffee-modal.active").removeClass("active");
        $("html").addClass("stuck");
        $("#" + modalId).addClass("active");
    });


    $(".trans-virtue").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    $(".testing .trans-tab").click(function(){
        
        var active_tab = $(".testing .trans-tab.active")
        var active_video = active_tab.find(".trans-img video")[0]
        if (active_video)
            active_video.pause()

        $(".testing .trans-tab.active").removeClass("active")
        
        
        var new_video = $(this).find(".trans-img video")[0]
        $(this).addClass("active")

        //if (window.innerWidth < 800)
            //$(this)[0].scrollIntoView({ behavior: "smooth" }); 

        if (!new_video) return
        new_video.play()
        

    })



    document.querySelectorAll('.stats svg [id^="stat-"]').forEach(function(el) {
        el.style.cursor = 'pointer';
        el.addEventListener('click', function() {
            $(".coffee-modal.active").removeClass("active");
            $("#" + el.id + "-modal").addClass("active");
        });
    });


    $(".a-stat-desc .button").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("#" + this_id).addClass("active")
    })

    // ATC - desktop subscription
    $(".subscribe-atc.desktop-only").click(function(){
        var that = $(this)
        if (that.data("adding") || !window.selected_variant || !window.selected_variant.id || !window.selected_variant.available) return

        var selected_subscription = $("#subscribe-selector").find(":selected")
        var freq_num = selected_subscription.val()
        var sub_id = parseInt(selected_subscription.attr("data-id"), 10)

        if (!freq_num || isNaN(sub_id)) {
            that.html("Select a plan")
            return
        }

        var id = window.selected_variant.id
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1
        var atc_options = {
            shipping_interval_frequency: freq_num,
            selling_plan: sub_id
        }

        that.data("adding", true).html("One Sec...")

        CartJS.addItem(id, qty, atc_options, {
            "success": function(line_item){
                if (typeof show_cart_confirm === "function") show_cart_confirm(line_item)
                $("header .cart-count").show()
                that.data("adding", false).html("Added!")
            },
            "error": function(e){
                console.log(e)
                that.data("adding", false).html("Error :(")
            }
        })
    })



    //showing and hiding the story popup
    $(".story-more-trigger").click(function(){
        $("html").addClass("stuck")
        $("#story-more").addClass("active")
    })
    
    //generic modal closing
    $(".modal-close").click(function(){
        $("html").removeClass("stuck")
        $(".coffee-modal.active").removeClass("active")
    })

    //showing and hiding brew guides for espresso/filter and english/spanish
    $(".guides .lang-selector button").click(function(){
        $(".lang-selector button.active").removeClass("active")
        $(this).addClass("active")
        brew_video_display_check()
    })
    $(".guides .guide-selector button").click(function(){
        $(".guide-selector button.active").removeClass("active")
        $(this).addClass("active")
        brew_video_display_check()
    })
    
    // all-selector (used by brew_guide_blocks schema)
    $(".guides .all-selector button").click(function(){
        $(".all-selector button.active").removeClass("active")
        $(this).addClass("active")
        var this_id = $(this).attr("data-guide")
        $(".guide-body.active").removeClass("active")
        $(".guide-body[data-guide='"+this_id+"']").addClass("active")
        $(".brew-timer-container.active").removeClass("active")
        $(".brew-timer-container[data-guide='"+this_id+"']").addClass("active")
    })

    //addon products
    $(".add-addon").click(function(){
        var variant = parseInt($(this).attr("data-variant-id"))
        var that = $(this)
        that.html("Going...")
        CartJS.addItem(variant,1, {}, {
            "success":function(line_item){
                that.html("Done!")
                show_cart_confirm(line_item)
                },
            "error":function(){
                that.html("Error :(")
            }
        });

    })

    function brew_video_display_check() {
        const lang = $(".lang-selector button.active").attr("data-lang") || "en";

        // source of truth on load
        const guide =
            $(".guides .all-selector button.active").attr("data-guide") ||
            $(".guides .all-selector button").first().attr("data-guide");

        if (!guide) return;

        // --- guide body ---
        $(".guide-body.active").removeClass("active");

        // Prefer lang match if guide bodies have data-lang, otherwise fall back to guide-only
        const $byLang = $(`.guide-body[data-guide='${guide}'][data-lang='${lang}']`);
        const $byGuide = $(`.guide-body[data-guide='${guide}']`);

        ($byLang.length ? $byLang : $byGuide).addClass("active");

        // --- timer ---
        $(".brew-timer-container.active").removeClass("active");
        $(`.brew-timer-container[data-guide='${guide}']`).addClass("active");
    }

    $(function () {
    brew_video_display_check();
    });
}





function setup_feat_prod_swiper() {

    var feat_prod_swipers = document.querySelectorAll(".feat-prod-slider .swiper")
    for (var swip of feat_prod_swipers){
        const swiper = new Swiper(swip, {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 20,
            // observer: true, 
            // observeParents: true,
            mousewheel: true,
            // And if we need scrollbar
            scrollbar: {
                draggable: true,
                el: '.swiper-scrollbar',
            },
        });
    }

}



// Box Overview Section Swiper & Navigation
document.addEventListener("DOMContentLoaded", () => {
    const swiperEl = document.querySelector("[data-overview-swiper]");
    if (!swiperEl || typeof Swiper === "undefined") return;

    // scope everything to the closest section so we don't accidentally grab the wrong elements
    const root = swiperEl.closest(".box-overview") || swiperEl.parentElement || document;

    const nav    = root.querySelector("[data-overview-tabs]");
    const btns   = nav ? Array.from(nav.querySelectorAll("[data-tab-btn]")) : [];
    const labels = Array.from(root.querySelectorAll(".tab-labels .tab-label"));

    const overviewSwiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        initialSlide: 0,
        speed: 350,
        autoHeight: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        simulateTouch: true,
        grabCursor: true,
        touchStartPreventDefault: false,
        observer: true,
        observeParents: true,
        on: {
            init(swiper) {
                syncNav(swiper.activeIndex);
            },
            slideChange(swiper) {
                syncNav(swiper.activeIndex);
            },
        }
    });

    function syncNav(index) {
        // update CSS var (used for your pill indicator)
        if (nav) nav.style.setProperty("--active-index", index);

        // toggle button active state
        btns.forEach((btn) => {
        const i = Number(btn.dataset.index);
        const active = i === index;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
        btn.toggleAttribute("disabled", active);
        });

        // toggle label active state
        labels.forEach((label) => {
        const i = Number(label.getAttribute("data-index"));
        label.classList.toggle("is-active", i === index);
        });
    }

    // clicking tabs moves swiper
    btns.forEach((btn) => {
        btn.addEventListener("click", () => {
        const index = Number(btn.dataset.index);
        if (Number.isNaN(index)) return;
        overviewSwiper.slideTo(index);
        });
    });

    window.overviewSwiper = overviewSwiper; // optional
});




// Coalesce frequent spline updates to a single rAF tick
var splineOps = [];
var splineRafId = null;
function queueSpline(op){
    splineOps.push(op);
    if (!splineRafId){
        splineRafId = requestAnimationFrame(function(){
            var ops = splineOps;
            splineOps = [];
            splineRafId = null;
            for (var i=0; i<ops.length; i++){
                try { ops[i](); } catch(e) {}
            }
        });
    }
}
